// extracted by mini-css-extract-plugin
module.exports = {"main":"ResultsSort_main__T1eJo","button":"ResultsSort_button__6PeyO","button___expanded":"ResultsSort_button___expanded__BUuzY","options":"ResultsSort_options__HWPlp"};